import { LRUCache } from "lru-cache";

export class Cache {
  private cache: LRUCache<string, any>;

  constructor(maxSize: number = 100000) {
    this.cache = new LRUCache<string, any>({ max: maxSize });
  }

  get(key: string): any | undefined {
    return this.cache.get(key);
  }

  set(key: string, value: any): void {
    this.cache.set(key, value);
  }

  has(key: string): boolean {
    return this.cache.has(key);
  }

  delete(key: string): boolean {
    return this.cache.delete(key);
  }

  clear(): void {
    this.cache.clear();
  }

  deleteByPattern(regex: RegExp): void {
    for (const key of this.cache.keys()) {
      if (typeof key === "string" && regex.test(key)) {
        this.cache.delete(key);
      }
    }
  }
}